import type { CurrentAcuityScoreResponse } from "@/core/types";
import { useCheckPermission } from "@/features/access-control/hooks/useCheckPermission";

import { EffectiveAcuityIndex } from "./EffectiveAcuityIndex";
import { PendingAcuityIndex } from "./PendingAcuityIndex";

type AcuityHeaderDetailsProps = {
  currentAcuityScore: CurrentAcuityScoreResponse;
};

export function AcuityHeaderDetails({ currentAcuityScore }: AcuityHeaderDetailsProps) {
  const { approval_requests, effective_score } = currentAcuityScore;
  const hasPendingApprovalRequest = approval_requests?.length > 0;

  const canViewPendingAcuity = useCheckPermission({
    permissionKey: "acuityScorePendingStatus",
  });

  return (
    <dl className="tw:flex tw:flex-col tw:gap-1">
      {hasPendingApprovalRequest && canViewPendingAcuity ? (
        <PendingAcuityIndex
          approval_requests={approval_requests}
          effective_score={effective_score}
        />
      ) : (
        <EffectiveAcuityIndex effective_score={effective_score} />
      )}
    </dl>
  );
}
